import React from 'react';
import PropTypes from 'prop-types';
import { formatBigNumber } from '../../../SleepHub/sleepHubApi';
import { CHART_COLORS } from '../../../../component/common/designSystem';

/**
 * A ranked bar list that honours the SHARE THE BACKEND SENT.
 *
 * The shared `ProgressList` recomputes each row's share as a fraction of the
 * rows it was handed, which is wrong for every list in this section: emotions
 * are multi-select so they sum past 100%, and any truncated top-N list sums to
 * less than the whole. The denominator belongs to whoever counted, so it is
 * passed through rather than re-derived. Same trap as the Scans and Cessation
 * hubs.
 */
const BarList = ({ rows, unit = 'logs', colorFor = () => CHART_COLORS.brand }) => (
  <ul className="space-y-4">
    {rows.map((row, index) => (
      <li key={row.label}>
        <div className="flex items-baseline justify-between gap-3">
          <span className="text-sm text-gray-600 dark:text-gray-300 truncate" title={row.label}>
            {row.label}
          </span>
          <span className="text-sm font-semibold text-shoorah-btn dark:text-white shrink-0">
            {row.share}%
            <span className="ml-1.5 font-normal text-gray-400">
              {formatBigNumber(row.count)} {unit}
            </span>
          </span>
        </div>
        <div className="mt-1.5 h-2 rounded-full bg-shoorah-normanGray dark:bg-shoorah-darkBgColor overflow-hidden">
          <div
            className="h-full rounded-full"
            style={{
              // A row with a real but tiny share still gets a visible sliver;
              // a genuinely empty row gets nothing.
              width: `${Math.max(Math.min(row.share, 100), row.count > 0 ? 2 : 0)}%`,
              backgroundColor: colorFor(index, row.label)
            }}
          />
        </div>
      </li>
    ))}
  </ul>
);

BarList.propTypes = {
  rows: PropTypes.array,
  unit: PropTypes.string,
  colorFor: PropTypes.func
};

export default BarList;
